import i18n from '@/libs/i18n'

export default [
  // *===============================================---*
  // *--------- Page ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/pages/list',
    name: 'pages-pages-list',
    component: () => import('@/views/pages/page/PagesList.vue'),
    meta: {
      resource: 'page',
      action: 'read',
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('pages.mainVerticalMenu.pages'),
    },
  },
  {
    path: '/pages/add',
    name: 'pages-pages-add',
    component: () => import('@/views/pages/page/PageAdd.vue'),
    meta: {
      resource: 'page',
      action: 'create',
      breadcrumb: [
        {
          text: i18n.t('general.add'),
          active: false,
        },
      ],
      pageTitle: i18n.t('pages.mainVerticalMenu.pages'),
    },
  },
  {
    path: '/pages/edit/:id',
    name: 'pages-pages-edit',
    component: () => import('@/views/pages/page/PageEdit.vue'),
    meta: {
      resource: 'page',
      action: 'update',
      breadcrumb: [
        {
          text: i18n.t('general.edit'),
          active: false,
        },
      ],
      pageTitle: i18n.t('pages.mainVerticalMenu.pages'),

    },
  },
  {
    path: '/pages/categories/list',
    name: 'pages-page-categories-list',
    component: () => import('@/views/pages/pageCategory/PageCategoryList.vue'),
    meta: {
      resource: 'pageCategory',
      action: 'read',
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('pageCategories.mainVerticalMenu.pageCategories'),
    },
  },
  {
    path: '/pages/categories/add',
    name: 'pages-page-categories-add',
    component: () => import('@/views/pages/pageCategory/PageCategoryAdd.vue'),
    meta: {
      resource: 'pageCategory',
      action: 'create',
      breadcrumb: [
        {
          text: i18n.t('general.add'),
          active: false,
          to: '/pages/categories/add',
        },
      ],
      pageTitle: i18n.t('pageCategories.mainVerticalMenu.pageCategories'),
    },
  },
  {
    path: '/pages/categories/edit/:id',
    name: 'pages-page-categories-edit',
    component: () => import('@/views/pages/pageCategory/PageCategoryEdit.vue'),
    meta: {
      resource: 'pageCategory',
      action: 'update',
      breadcrumb: [
        {
          text: i18n.t('general.edit'),
          active: false,
          to: '/pages/categories/add',
        },
      ],
      pageTitle: i18n.t('pageCategories.mainVerticalMenu.pageCategories'),
    },
  },
]
